import { NgModule } from '@angular/core';
import { ChartComponent } from './chart.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
  declarations: [ ChartComponent ],
  providers: [provideCharts(withDefaultRegisterables())],
  exports: [ ChartComponent ]
})
export class ChartModule {
  constructor() { }
}